module.exports = __webpack_public_path__ + "img/scsx.f88ab6ac.png";